import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../session.service';

/**
 * Réserve l'accès aux administrateurs (ROLE_ADMIN). Les autres rôles (ex. agent)
 * sont redirigés vers la page 403. Un agent ne peut accéder qu'aux pages
 * « Délivrer » et « Historique », qui ne portent pas ce guard.
 * Utilisable en canActivate comme en canActivateChild (même signature).
 */
export const adminGuard: CanActivateFn = () => {
    const session = inject(SessionService);
    const router = inject(Router);

    if (session.hasRole('ROLE_ADMIN')) {
        return true;
    }
    return router.parseUrl('/error/403');
};
